import { Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import React from "react";

import constant from "@/config/constant";
import moment from "moment";
import { useSelector } from "react-redux";

// Fetch
import { createProduct, updateProduct } from "@/fetch/fetchProduct";
import _ from "lodash";
//create Dialog to add product record
const ProductManageDialog = ({
  brand,
  dialogOpen,
  setDialogOpen,
  fetchAll,
  editData,
  handleOnChange,
  actions,
  handleOnSuccess,
  handleOnFailed,
  productData,
  categoriesOption,
}) => {
  const [isManningsCodeUpdated, setIsManningsCodeUpdated] =
    React.useState(false);
  const [value, setValue] = React.useState(moment().format("YYYY-MM-01"));
  const [error, setError] = React.useState({
    brand_types_id: "",
    m18_product_code: "",
    mannings_product_code: "",
    product_name: "",
    product_unit_price: "",
  });
  const departmentId = useSelector((state) => state.user.departmentId);

  const handleClose = () => {
    setDialogOpen((prev) => !prev);
    setError({
      brand_types_id: "",
      m18_product_code: "",
      mannings_product_code: "",
      product_name: "",
      product_unit_price: "",
    });
  };

  return (
    <React.Fragment>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: async (event) => {
            if (!actions?.update) return;
            try {
              event.preventDefault();
              const func = (value, num = "", isManningsCode = false) => {
                let text = "";
                const targetManningsCode = productData.find(
                  (item) => item.mannings_product_code === value
                );

                if (!value) {
                  text = "沒有資料";
                } else if (num && isNaN(parseInt(value))) {
                  text = "不能是文字";
                } else if (
                  isManningsCode &&
                  targetManningsCode &&
                  isManningsCodeUpdated
                ) {
                  text = "號碼已存在";
                }
                return text;
              };

              const formJsonError = {
                brand_types_id: func(editData.brand_types_id),
                m18_product_code: func(editData.m18_product_code),
                mannings_product_code: func(
                  editData.mannings_product_code,
                  "",
                  true
                ),
                product_name: func(editData.product_name),
                product_unit_price: func(editData.product_unit_price, 1),
              };
              const isValid = () =>
                Object.values(formJsonError).every((item) =>
                  item === "" ? true : false
                );

              setError(formJsonError);
              if (isValid()) {
                if (editData.id) {
                  await updateProduct(editData);
                  handleOnSuccess(editData);
                } else {
                  await createProduct(editData);
                  fetchAll();
                }
                handleClose();
              } else {
                handleOnFailed();
              }
            } catch (e) {
              handleOnFailed();
              console.log(e);
            } finally {
            }
          },
        }}
      >
        <DialogTitle>{editData.id ? "更新產品" : "新增產品"}</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }} />
          <Grid container spacing={2}>
            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="demo-simple-select-label">品牌</InputLabel>
                <Select
                  disabled={!actions?.update}
                  error={!!error.brand_types_id}
                  labelId="demo-simple-select-label"
                  name="brand_types_id"
                  id="brand_types_id"
                  value={editData.brand_types_id}
                  label="品牌"
                  onChange={(event) => {
                    handleOnChange("brand_types_id", event.target.value);
                  }}
                  helperText={error.brand_types_id}
                >
                  {brand.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.id}>
                        {item.brand_types_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 8,
                lg: 8,
              }}
            >
              <TextField
                disabled={!actions?.update}
                error={!!error.product_name}
                margin="dense"
                id="product_name"
                name="product_name"
                label="產品名稱"
                type="text"
                value={editData.product_name}
                onChange={(event) =>
                  handleOnChange("product_name", event.target.value)
                }
                fullWidth
                variant="standard"
                helperText={error.product_name}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <TextField
                disabled={!actions?.update}
                error={!!error.m18_product_code}
                margin="dense"
                id="m18_product_code"
                name="m18_product_code"
                label="M18 號碼"
                type="text"
                value={editData.m18_product_code}
                onChange={(event) =>
                  handleOnChange("m18_product_code", event.target.value)
                }
                fullWidth
                variant="standard"
                helperText={error.m18_product_code}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <TextField
                disabled={!actions?.update}
                error={!!error.mannings_product_code}
                margin="dense"
                id="mannings_product_code"
                name="mannings_product_code"
                label="萬寧號碼"
                value={editData.mannings_product_code}
                onChange={(event) => {
                  handleOnChange("mannings_product_code", event.target.value);
                  setIsManningsCodeUpdated(true);
                }}
                type="text"
                fullWidth
                variant="standard"
                helperText={error.mannings_product_code}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <TextField
                disabled={!actions?.update}
                error={!!error.product_unit_price}
                margin="dense"
                id="product_unit_price"
                name="product_unit_price"
                label="產品單價價錢"
                value={editData.product_unit_price}
                onChange={(event) => {
                  handleOnChange("product_unit_price", event.target.value);
                }}
                type="number"
                fullWidth
                variant="standard"
                helperText={error.product_unit_price}
              />
            </Grid>

            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="select-brands-label">區域</InputLabel>
                <Select
                  disabled={!actions?.update}
                  required
                  id="region_id"
                  name="region_id"
                  label="區域"
                  labelId="select-region-label"
                  onChange={(event) =>
                    handleOnChange("region_id", event.target.value)
                  }
                  value={editData.region_id}
                >
                  <MenuItem key={"1"} value={1}>
                    香港
                  </MenuItem>
                  <MenuItem key={"2"} value={2}>
                    澳門
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
                lg: 4,
              }}
            >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="select-brands-label">種類</InputLabel>
                <Select
                  disabled={!actions?.update && !actions?.update_category}
                  multiple
                  id="type"
                  name="type"
                  label="員工購物"
                  labelId="select-brands-label"
                  renderValue={(selected) => {
                    const selectedValue = _.map(selected, (s) => {
                      return constant.productType[s];
                    });
                    return selectedValue.join(", ");
                  }}
                  onChange={(event) =>
                    handleOnChange("type", event.target.value)
                  }
                  value={editData.type}
                >
                  {_.map(constant.productType, (value, key) => {
                    return (
                      <MenuItem
                        disabled={
                          key === "mannings" &&
                          ![4, 5, 1].includes(departmentId)
                        }
                        value={key}
                        key={key}
                      >
                        <Checkbox checked={editData.type.includes(key)} />
                        <ListItemText primary={value} />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 2,
                lg: 2,
              }}
            >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="select-brands-label">共用CODE</InputLabel>
                <Select
                  disabled={!actions?.update}
                  required
                  id="muti_region"
                  name="muti_region"
                  label="共用CODE"
                  labelId="select-brands-label"
                  onChange={(event) =>
                    handleOnChange("muti_region", event.target.value)
                  }
                  value={editData.muti_region}
                >
                  <MenuItem key={"on"} value={true}>
                    開啟
                  </MenuItem>
                  <MenuItem key={"off"} value={false}>
                    關閉
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid
              size={{
                xs: 12,
                md: 2,
                lg: 2,
              }}
            >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="select-brands-label">報數列表</InputLabel>
                <Select
                  disabled={!actions?.update}
                  required
                  id="is_active"
                  name="is_active"
                  label="報數列表"
                  labelId="select-brands-label"
                  onChange={(event) =>
                    handleOnChange("is_active", event.target.value)
                  }
                  value={editData.is_active}
                >
                  <MenuItem key={"on"} value={true}>
                    開啟
                  </MenuItem>
                  <MenuItem key={"off"} value={false}>
                    關閉
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 12,
                lg: 12,
              }}
            >
              <Autocomplete
                multiple
                value={editData.categories}
                id="tags-filled"
                options={categoriesOption.map((option) => option)}
                onChange={(e, newValue) => {
                  handleOnChange("categories", newValue);
                }}
                freeSolo
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return <Chip label={option} key={key} {...tagProps} />;
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    label="Tag"
                    placeholder="Tag"
                  />
                )}
              />
            </Grid>

            {actions.trade_discount && (
              <React.Fragment>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                >
                  <StaticDatePicker
                    minDate={"2018-01-01"}
                    maxDate={"2025-12-31"}
                    displayStaticWrapperAs="desktop"
                    value={value}
                    onChange={(newValue) => {
                      setValue(moment(newValue).format("YYYYMM"));
                    }}
                    openTo="month"
                    views={["year", "month"]}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                >
                  <FormControl variant="standard">
                    <InputLabel htmlFor="trade_discount">
                      Trade Discount
                    </InputLabel>
                    <Input
                      id="trade_discount"
                      type="number"
                      endAdornment={
                        <InputAdornment position="end">%</InputAdornment>
                      }
                      aria-describedby="trade_discount"
                      inputProps={{
                        "aria-label": "percent",
                      }}
                      value={
                        editData.trade_discount?.[
                          moment(value).format("YYYYMM")
                        ] ?? 0
                      }
                      onChange={(event) => {
                        let trade_discount = {
                          ...editData.trade_discount,
                          [moment(value).format("YYYYMM")]: event.target.value,
                        };
                        handleOnChange("trade_discount", trade_discount);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 4,
                    lg: 4,
                  }}
                >
                  <FormControl variant="standard">
                    <InputLabel htmlFor="margin">Margin</InputLabel>
                    <Input
                      id="margin"
                      type="number"
                      endAdornment={
                        <InputAdornment position="end">%</InputAdornment>
                      }
                      aria-describedby="margin"
                      inputProps={{
                        "aria-label": "percent",
                      }}
                      value={editData.margin}
                      onChange={(event) => {
                        handleOnChange(
                          "margin",
                          parseFloat(event.target.value)
                        );
                      }}
                    />
                  </FormControl>
                </Grid>
              </React.Fragment>
            )}
          </Grid>
        </DialogContent>
        {(actions?.update || actions?.update_category) && (
          <DialogActions>
            <Button sx={{ fontSize: 16 }} onClick={handleClose}>
              取消
            </Button>
            <Button sx={{ fontSize: 16 }} type="submit">
              儲存
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default ProductManageDialog;
